import * as React from 'react'
import { Text, Stack, Colors } from '@doordash/design-language'
import Button from '@doordash/component-button'
import { SectionContainer } from '../../StyleComponents'
import { i18nKeys } from 'translationTypes'
import i18n from '../../../../../i18n'

export const SubmitSection = ({ onClick, onAnimationEnd, buttonState }) => (
  <Stack size={Stack.Sizes.XLarge}>
    <SectionContainer>
      <Text styles={Text.Styles.Bold32}>
        {i18n.t(i18nKeys.safetyCourse__title_courseConclusion)}
      </Text>
      <Stack>
        <Text styles={Text.Styles.SectionSubtext} color={Colors.TextSecondary}>
          {i18n.t(i18nKeys.safetyCourse__description_courseConclusion)}
        </Text>
      </Stack>
      <Button
        type={Button.Types.PrimaryPill}
        size={Button.Sizes.Large}
        onClick={onClick}
        state={buttonState}
        onAnimationEnd={status => onAnimationEnd(status)}
      >
        {i18n.t(i18nKeys.safetyCourse__completeCourseButton)}
      </Button>
      <Text color={Text.Colors.TextSecondary} styles={Text.Styles.Medium12}>
        {i18n.t(i18nKeys.safetyCourse__completeCourseButtonDescription)}
      </Text>
    </SectionContainer>
  </Stack>
)
